export enum AuthorizationPages {
    DownloadApp,
    HelpAlert,
    HowToUseTokenToro,
    AuthorizeTokenToro,
    AuthorizeSmsToken,
    AuthorizeEmailToken,
    RegisterBankAccountSuccess,
    Blocked,
}
